import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Nasıl Çalışır?', href: '/#how-it-works' },
    { label: 'Özellikler', href: '/#features' },
    { label: 'Güvenlik', href: '/#safety' },
    { label: 'Premium', href: '/premium' },
  ];

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-black/80 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/0758b00e-4705-432c-90d8-8173dccd9e57.png"
            alt="ChatNow Logo"
            className="h-8 md:h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/settings"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/50 hover:text-white hover:bg-white/10 transition-all cursor-pointer"
            title="Ayarlar"
          >
            <i className="ri-settings-3-line text-sm" />
          </Link>
          <Link
            to="/auth"
            className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
          >
            Giriş Yap
          </Link>
          <Link
            to="/auth?mode=register"
            className="px-5 py-2.5 rounded-full text-sm font-semibold bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-400 hover:to-blue-500 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-cyan-500/20"
          >
            Hemen Başla
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white/80 hover:text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/5 px-4 pb-6 pt-4">
          <nav className="flex flex-col gap-4 mb-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-white/70 hover:text-white text-base transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="flex flex-col gap-3">
            <Link
              to="/auth"
              onClick={() => setMobileOpen(false)}
              className="text-center py-3 border border-white/20 rounded-full text-white/80 hover:text-white text-sm cursor-pointer"
            >
              Giriş Yap
            </Link>
            <Link
              to="/auth?mode=register"
              onClick={() => setMobileOpen(false)}
              className="text-center py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-cyan-500 to-blue-600 text-white cursor-pointer"
            >
              Hemen Başla
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
